import cover from 'assets/cover.png';
import LocationSearch from '../locations/LocationSearch';

function LandingPage() {
  return (
    <div data-testid="page-landing" className="mx-auto mt-12 max-w-screen-lg">
      <div className="flex items-center">
        <div>
          <div className="mb-2 text-4xl font-thin">
            Accurate, reliable, and up-to-date weather forecasts
          </div>
          <div className="mb-4 text-xl font-thin">
            Before you venture outdoors, check the conditions.
          </div>
          <div className="sm:hidden">
            <LocationSearch />
          </div>
        </div>
        <img
          src={cover}
          alt="Weather App"
          className="ml-8 hidden w-1/2 rounded-xl shadow-xl md:block"
        />
      </div>
    </div>
  );
}

export default LandingPage;
